/**
 * FantasticFractals - Curated Catalog of Famous Fractals & Zoom Landmarks
 */

export const FRACTAL_PRESETS = [
  {
    id: 'mandelbrot_classic',
    name: 'Mandelbrot Full Overview',
    type: 'mandelbrot',
    category: 'Mandelbrot',
    centerX: -0.7,
    centerY: 0.0,
    zoom: 1.0,
    iterations: 120,
    palette: 'cyberpunk',
    description: 'The complete classical Mandelbrot set with its primary cardioid and period bulbs.',
  },
  {
    id: 'seahorse_valley',
    name: 'Seahorse Valley',
    type: 'mandelbrot',
    category: 'Mandelbrot',
    centerX: -0.743643887037158704752191506114774,
    centerY: 0.131825904205311970493132056385139,
    zoom: 350.0,
    iterations: 260,
    palette: 'ocean',
    description: 'The hypnotic swirling spiraling corridors between the main cardioid and the period-2 head bulb.',
  },
  {
    id: 'elephant_valley',
    name: 'Elephant Valley',
    type: 'mandelbrot',
    category: 'Mandelbrot',
    centerX: 0.3012,
    centerY: -0.0245,
    zoom: 45.0,
    iterations: 220,
    palette: 'sunset',
    description: 'Ornate structures resembling trunks and parades of majestic elephants.',
  },
  {
    id: 'minibrot_satellite',
    name: 'Satellite Mini-Brot',
    type: 'mandelbrot',
    category: 'Mandelbrot',
    centerX: -1.768778833,
    centerY: -0.001738994,
    zoom: 800.0,
    iterations: 350,
    palette: 'fire',
    description: 'A miniature replica of the entire Mandelbrot set submerged deep in antennae filaments.',
  },
  {
    id: 'triple_spiral',
    name: 'Triple Spiral Nebula',
    type: 'mandelbrot',
    category: 'Mandelbrot',
    centerX: -0.088,
    centerY: 0.654,
    zoom: 180.0,
    iterations: 280,
    palette: 'psychedelic',
    description: 'Three-armed recursive vortexes intertwining into infinity.',
  },
  {
    id: 'douady_rabbit',
    name: 'Douady Rabbit',
    type: 'julia',
    category: 'Julia Sets',
    centerX: 0.0,
    centerY: 0.0,
    zoom: 1.1,
    iterations: 150,
    palette: 'emerald',
    juliaReal: -0.123,
    juliaImag: 0.745,
    description: 'Three-eared pinched Julia set named by Adrien Douady and John H. Hubbard.',
  },
  {
    id: 'dendrite_fractal',
    name: 'Dendrite Tree',
    type: 'julia',
    category: 'Julia Sets',
    centerX: 0.0,
    centerY: 0.0,
    zoom: 1.0,
    iterations: 160,
    palette: 'cyberpunk',
    juliaReal: 0.0,
    juliaImag: 1.0,
    description: 'Tree-like branched antenna network having zero interior area.',
  },
  {
    id: 'san_marco',
    name: 'San Marco Dragon',
    type: 'julia',
    category: 'Julia Sets',
    centerX: 0.0,
    centerY: 0.0,
    zoom: 1.0,
    iterations: 140,
    palette: 'sunset',
    juliaReal: -0.75,
    juliaImag: 0.0,
    description: 'Reflective symmetry reminiscent of the basilica domes of San Marco in Venice.',
  },
  {
    id: 'starfish_julia',
    name: 'Electric Starfish',
    type: 'julia',
    category: 'Julia Sets',
    centerX: 0.0,
    centerY: 0.0,
    zoom: 1.1,
    iterations: 180,
    palette: 'fire',
    juliaReal: -0.7,
    juliaImag: 0.27015,
    description: 'Radially blooming filaments exploding in all directions.',
  },
  {
    id: 'burning_ship_masts',
    name: 'Burning Ship Masts & Rigging',
    type: 'burning_ship',
    category: 'Burning Ship',
    centerX: -0.45,
    centerY: -0.5,
    zoom: 1.0,
    iterations: 150,
    palette: 'fire',
    description: 'Dark ghost galleons with blazing sails and towering spectral masts.',
  },
  {
    id: 'burning_ship_antenna',
    name: 'Armada Deep Fleet',
    type: 'burning_ship',
    category: 'Burning Ship',
    centerX: -1.755,
    centerY: -0.03,
    zoom: 50.0,
    iterations: 240,
    palette: 'cyberpunk',
    description: 'Intricate gothic armadas marching along the fiery horizon.',
  },
  {
    id: 'tricorn_main',
    name: 'Tricorn (Mandelbar)',
    type: 'tricorn',
    category: 'Tricorn',
    centerX: 0.0,
    centerY: 0.0,
    zoom: 0.9,
    iterations: 130,
    palette: 'rainbow',
    description: 'Conjugate quadratic polynomial showing three-cornered hyperbolic bays.',
  },
  {
    id: 'multibrot_3',
    name: 'Cubic Multibrot (d=3)',
    type: 'multibrot3',
    category: 'Multibrot',
    centerX: 0.0,
    centerY: 0.0,
    zoom: 0.9,
    iterations: 120,
    palette: 'ocean',
    description: 'Two main cardioid bulbs with symmetrical secondary antennae.',
  },
  {
    id: 'multibrot_4',
    name: 'Quartic Multibrot (d=4)',
    type: 'multibrot4',
    category: 'Multibrot',
    centerX: 0.0,
    centerY: 0.0,
    zoom: 0.9,
    iterations: 120,
    palette: 'monochrome',
    description: 'Three-fold rotational symmetry with crystal lattice boundaries.',
  },
  {
    id: 'newton_roots',
    name: 'Newton-Raphson Basins (z³ = 1)',
    type: 'newton',
    category: 'Newton',
    centerX: 0.0,
    centerY: 0.0,
    zoom: 0.8,
    iterations: 80,
    palette: 'rainbow',
    description: 'Interlaced basins of attraction with infinite fractal boundaries between roots.',
  },
  {
    id: 'nova_spiral',
    name: 'Nova Relaxation Hybrid',
    type: 'nova',
    category: 'Nova',
    centerX: 0.0,
    centerY: 0.0,
    zoom: 0.8,
    iterations: 90,
    palette: 'emerald',
    description: 'Dynamic convergence spirals of the Nova fractal formula.',
  },
  {
    id: 'collatz_web',
    name: 'Collatz Complex Dynamics',
    type: 'collatz',
    category: 'Collatz',
    centerX: 0.0,
    centerY: 0.0,
    zoom: 0.35,
    iterations: 70,
    palette: 'psychedelic',
    description: 'Unsolved 3n+1 conjecture geometry mapped across the complex plane.',
  },
  {
    id: 'lyapunov_chaos',
    name: 'Lyapunov Stability Map',
    type: 'lyapunov',
    category: 'Lyapunov',
    centerX: 3.82,
    centerY: 3.82,
    zoom: 3.5,
    iterations: 120,
    palette: 'sunset',
    description: 'Order and chaos boundary separating periodic attractors and turbulent bifurcation.',
  },
  {
    id: 'sierpinski_box',
    name: 'Sierpinski Carpet Matrix',
    type: 'sierpinski_carpet',
    category: 'Geometric',
    centerX: 0.5,
    centerY: 0.5,
    zoom: 1.0,
    iterations: 7,
    palette: 'monochrome',
    description: 'Self-similar recursive square subdivision with fractional Hausdorff dimension ~1.89.',
  },
  {
    id: 'sierpinski_gasket',
    name: 'Sierpinski Triangle (Gasket)',
    type: 'sierpinski_triangle',
    category: 'Geometric',
    centerX: 0.0,
    centerY: 0.3,
    zoom: 0.85,
    iterations: 9,
    palette: 'cyberpunk',
    description: 'Equilateral triangular recursive gasket with Hausdorff dimension ~1.585.',
  },
  {
    id: 'koch_snowflake_island',
    name: 'Koch Snowflake Island',
    type: 'koch_snowflake',
    category: 'Geometric',
    centerX: 0.0,
    centerY: 0.0,
    zoom: 0.85,
    iterations: 7,
    palette: 'ocean',
    description: 'Infinite crystalline perimeter enclosing finite hexagonal area.',
  },
  {
    id: 'vicsek_cross',
    name: 'Vicsek Cross Fractal',
    type: 'vicsek',
    category: 'Geometric',
    centerX: 0.5,
    centerY: 0.5,
    zoom: 1.0,
    iterations: 6,
    palette: 'fire',
    description: 'Recursive 9-square cross dissection displaying cardinal symmetry.',
  },
  {
    id: 'celtic_mandelbrot_knots',
    name: 'Celtic Intertwined Knotwork',
    type: 'celtic_mandelbrot',
    category: 'Mandelbrot',
    centerX: -0.5,
    centerY: 0.0,
    zoom: 1.0,
    iterations: 130,
    palette: 'emerald',
    description: 'Woven Celtic knot filaments created by reflecting real squaring components.',
  },
  {
    id: 'buffalo_peaks',
    name: 'Buffalo Horned Peaks',
    type: 'buffalo',
    category: 'Mandelbrot',
    centerX: -0.5,
    centerY: 0.0,
    zoom: 1.0,
    iterations: 140,
    palette: 'fire',
    description: 'Spiky gothic buffalo silhouette with aggressive non-analytic branches.',
  },
  {
    id: 'magnet_spin_glass',
    name: 'Potts Spin Glass Boundary',
    type: 'magnet1',
    category: 'Mandelbrot',
    centerX: 0.5,
    centerY: 0.0,
    zoom: 0.9,
    iterations: 100,
    palette: 'rainbow',
    description: 'Statistical physics magnetization phase transitions in the complex plane.',
  },
  {
    id: 'apollonian_rings',
    name: 'Apollonian Inversion Circles',
    type: 'apollonian',
    category: 'Geometric',
    centerX: 0.0,
    centerY: 0.0,
    zoom: 0.9,
    iterations: 14,
    palette: 'psychedelic',
    description: 'Mutually kissing osculating circle inversions creating a dense foam lattice.',
  }
];
